import {request_url} from './config';
import {getToken} from './auth';
import {Message} from 'view-design';
import axios from 'axios';
import store from '@/store';

//post请求封装
export function request(url, data = {}, option = {}) {
    return new Promise((resolve, reject) => {
        const headers = option.headers || {};
        headers['content-type'] = 'application/json;charset=UTF-8';
        const token = getToken();
        if (token) headers['access-token'] = token;
        axios({
            url: (option.host || request_url) + url,
            data: data,
            method: option.method || 'post',
            headers,
            responseType: option.responseType || 'json'
        }).then((result) => {
            const res = result.data;
            resolve(res);
            if (res.status == 40101) {
                store.commit('login_out');
            } else if ((option.toast == undefined) && res.status !== 200) Message.warning(res.message);
        }).catch((e) => {
            reject(e);
            Message.error('服务器请求出错');
        });
    });
}

export function post(url, data = {}, option = {}) {
    return request(url, data, option);
}

//get请求封装
export function get(url, data, option = {}) {
    return request(url, data, {method: 'get', ...option});
}

//公共查询接口
export function select(key, data = {}, options = {}) {
    const {prefix = 'notToken/', module = 'publicController/', method = 'getValueByApp/', ...option} = options;
    const url = `${prefix}${module}${method}` + key;
    return request(url, data, option);
}

//公共单项查询接口
export function query(key, data = {}, options = {}) {
    const {prefix = 'notToken/', module = 'publicController/', method = 'getValueByApp/', ...option} = options;
    const url = `${prefix}${module}${method}` + key;
    const paraList = [];
    let returnField = null;

    Object.keys(data).forEach(key => {
        if (key === 'returnField' && Array.isArray(data.returnField)) returnField = data.returnField;
        else paraList.push({column: key, value: data[key]});
    });
    const params = {};
    if (paraList.length > 0) params.paraList = paraList;
    if (returnField) params.returnField = returnField;
    return request(url, params, option);
}

//公共单项查询接口-带token
export function queryByToken(key, data = {}, options = {}) {
    return query(key, data, {...options, prefix: 'token/'});
}

//公共查看详情接口
export function selectDetail(key, data = {}, options = {}) {
    return select(key, data, options);
}

//公共通过_id查看详情接口
export function selectDetailById(key, id, options = {}) {
    return query(key, {_id: id}, options);
}

//公共删除接口-带token
export function deleteByToken(key, ids) {
    return request(`token/publicController/deleteByid/${key}`, ids);
}

//下载接口
export function download(url, data = {}, option = {}) {
    return new Promise((resolve, reject) => {
        const headers = option.headers || {};
        headers['Content-type'] = 'application/json;application/octet-stream';
        const token = getToken();
        if (token) headers['access-token'] = token;
        axios({
            url: (option.host || request_url) + url,
            data: data,
            method: option.method || 'post',
            headers,
            responseType: 'blob'
        }).then((result) => {
            const res = result;
            resolve(res);
            if (res.status == 40101) {
                store.commit('login_out');
            } else if ((option.toast == undefined) && res.status !== 200) Message.warning(res.message);
        }).catch((e) => {
            reject(e);
            Message.error('服务器请求出错');
        });
    });
}
